import * as React from "react";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { useStore } from "../Page";
import styles from "./MainPanel.module.less";
import ContentPanel from "../ContentPanel/ContentPanel";

export const mainPanelId = "MainPanelId";
export const headerPanelId = "HeaderPanelId";

type MainPanelProps = {
  className?: string;
  color?: "ligthgrey" | "white";
  children?: React.ReactNode;
  fullwidth?: boolean;
};

const MainPanel: React.FC<MainPanelProps> = ({ className, color = "ligthgrey", fullwidth, children }) => {
  const [state, setState] = useStore();

  React.useLayoutEffect(() => {
    setState((prev) => ({ ...prev, mainPanel: true }));
    return () => {
      setState((prev) => ({ ...prev, mainPanel: false }));
    };
  }, [setState]);

  const mainPanelClassName = cls(
    {
      [styles.mainPanel]: true,
      [styles.mainPanelWhite]: color === "white",
    },
    className
  );

  return (
    <main id={mainPanelId} className={mainPanelClassName}>
      <div id={headerPanelId} />
      {state.contentPanel || fullwidth ? children : <ContentPanel data-implicit>{children}</ContentPanel>}
    </main>
  );
};

export default MainPanel;
